/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import _ from 'lodash';
import PulpoField from '../../../pulpo_visualizer/fields';
import styles from '../badging.module.scss';

class DefaultFields extends Component {
  state = {
    currentValue: undefined
  }


  static getDerivedStateFromProps(props, state) {
    if (props.info && props.info.logged_by && props.info.logged_by.id && state.currentValue === undefined) {
      return { ...state,
        currentValue: props.info.logged_by.fullname
      };
    }
    return state;
  }


  handleAutocompleteSelect = (val, item) => {
    const { handleAnswerChanged, handleFieldErrorChanged } = this.props;
    this.setState({ currentValue: val });
    handleAnswerChanged('info', item, 'logged_by');
    handleFieldErrorChanged('logged_by', false);
  }

  handleRemoveImage = (r) => {
    const { handleAnswerChanged, info } = this.props;
    const res = info.attachments.filter(e => e !== r);
    handleAnswerChanged('info', res, 'attachments');
    const removedList = info.removedAttachments || [];
    handleAnswerChanged('info', [...removedList, r.id], 'removedAttachments');
  }

  handleDrop = (dropped) => {
    const { handleAnswerChanged, info } = this.props;
    handleAnswerChanged('info', [...info.attachments, ...dropped], 'attachments');
  }


  render() {
    const {
      handleAnswerChanged,
      handleFieldErrorChanged,
      info,
      showFieldErrors
    } = this.props;

    return (
      <>
        <div className={styles.createform}>
          <div className={styles.lease}>
            <FormattedMessage
              id="badge.create.applicant_information"
              defaultMessage="Applicant Information"
            />
          </div>
          <div className={styles.halfformfield}>
            <PulpoField
              key="first_name"
              id="first_name"
              type="string"
              translationID="noise_log.public.name"
              title="First Name"
              isRequired
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.first_name}
              showFieldErrors={showFieldErrors}
              handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            />
            <PulpoField
              key="last_name"
              id="last_name"
              type="string"
              translationID="portal.user.last_name"
              title="Last Name"
              isRequired
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.last_name}
              showFieldErrors={showFieldErrors}
              handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            />
          </div>
          <div className={styles.halfformfield}>
            <PulpoField key="email" id="email" type="string" title="Email"
              translationID="forms.complete.email"
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.email} isRequired
              showFieldErrors={showFieldErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <PulpoField
              key="phone_number"
              id="phone_number"
              type="telephone"
              translationID="servicerequest.create.person_phone"
              className={styles.fullInput}
              title="Phone Number" isRequired
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.phone_number}
              showFieldErrors={showFieldErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
          </div>
        </div>
      </>
    );
  }
}

export default injectIntl(DefaultFields);
